// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.details-header {
  padding: 1rem 2rem;
  margin-top: 5px;
  background: white;
  border-bottom: 1px solid #eee;
}

.form-section {
  padding: 2.5rem;
  background: white;
  border-radius: 16px;
  margin-bottom: 2rem;
}

.form-control-custom {
  background-color: #f3f4f6 !important;
  border: none !important;
  border-bottom: 2px solid #374151 !important;
  border-radius: 8px 8px 0 0 !important;
  padding: 12px 16px !important;
  font-weight: 700 !important;
  color: #111827 !important;
}

.form-control-custom:focus {
  box-shadow: none !important;
  border-bottom-color: #3b82f6 !important;
}

.form-label-custom {
  font-size: 11px;
  text-transform: none;
  color: #6b7280;
  margin-bottom: 4px;
  font-weight: 500;
}


.custom-card {
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  background: white;
  overflow: hidden;
  height: 100%;
}

.subscription-card {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
}

.subscription-card.phone {
  border: 2px solid #a855f7;
}

.subscription-card.support {
  border: 2px solid #06b6d4;
}

.metric-box {
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  border-left: 4px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.metric-box.purple { border-left-color: #8C1AFF; }
.metric-box.cyan { border-left-color: #00E5FF; }
.metric-box.blue { border-left-color: #3b82f6; }

.avatar-stack {
  display: flex;
  align-items: center;
}

.avatar-stack img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid white;
  margin-left: -8px;
}

.avatar-stack img:first-child {
  margin-left: 0;
}

.btn-purple {
  background-color: #a855f7;
  color: white;
}

.btn-cyan {
  background-color: #06b6d4;
  color: white;
}

/* Activity Log CSS from jobpro-admin */
.but-cover {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.but-cover .but {
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 100%;
  padding: 8px;
  cursor: pointer;
}

.but-cover::before {
  content: " ";
  border-left: 1.5px dashed #4f4f4f;
  height: 90%;
  position: absolute;
  top: 40px;
  left: 33px;
}

.child-but-cover {
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 100%;
  padding: 8px;
  position: absolute;
  left: -15%;
}

.btn-topup {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  color: #666;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 4px;
}

.stat-change {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-change.up { color: #10b981; }
.stat-change.down { color: #ef4444; }

.license-control {
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 4px 12px;
  width: -moz-fit-content;
  width: fit-content;
}

.license-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #374151;
  padding: 0 8px;
}

.chart-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 13px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.tab-btn {
  padding: 8px 16px;
  border: none;
  background: none;
  color: #666;
  font-weight: 500;
  border-bottom: 2px solid transparent;
}

.tab-btn.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
  background: #eff6ff;
  border-radius: 8px 8px 0 0;
}

.action-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 1rem 0;
}

.search-input-group {
  position: relative;
  flex: 1 1;
}

.search-input-group svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
}

.search-input-group input {
  padding-left: 40px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.form-select-custom {
  line-height: 2rem;
}

.custom-phone-input {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 2px;
}

.custom-phone-input .PhoneInputInput {
  border: none;
  font-weight: 700;
  outline: none;
}

.custom-phone-input .PhoneInputCountryIcon {
  border-radius: 50%;
  overflow: hidden;
  border: none;
  box-shadow: none;
}

.custom-phone-input .PhoneInputCountryIconImg {
  border-radius: 50%;
}

.border-purple { border-color: #a855f7 !important; }
.border-cyan { border-color: #06b6d4 !important; }
.border-blue { border-color: #3b82f6 !important; }

.text-purple { color: #a855f7; }
.text-cyan { color: #06b6d4; }

.progress-bar.bg-purple-custom {
  background-color: #a855f7 !important;
}

.progress-bar.bg-cyan-custom {
  background-color: #06b6d4 !important;
}

`, "",{"version":3,"sources":["webpack://./src/pages/enterprise-plan/CompanyDetails.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2CAA2C;EAC3C,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,qBAAqB,0BAA0B,EAAE;AACjD,mBAAmB,0BAA0B,EAAE;AAC/C,mBAAmB,0BAA0B,EAAE;;AAE/C;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB,cAAc,EAAE;AAClC,oBAAoB,cAAc,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB,gCAAgC,EAAE;AACnD,eAAe,gCAAgC,EAAE;AACjD,eAAe,gCAAgC,EAAE;;AAEjD,eAAe,cAAc,EAAE;AAC/B,aAAa,cAAc,EAAE;;AAE7B;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".details-page {\n  background-color: #f8f9fa;\n  min-height: 100vh;\n}\n\n.details-header {\n  padding: 1rem 2rem;\n  margin-top: 5px;\n  background: white;\n  border-bottom: 1px solid #eee;\n}\n\n.form-section {\n  padding: 2.5rem;\n  background: white;\n  border-radius: 16px;\n  margin-bottom: 2rem;\n}\n\n.form-control-custom {\n  background-color: #f3f4f6 !important;\n  border: none !important;\n  border-bottom: 2px solid #374151 !important;\n  border-radius: 8px 8px 0 0 !important;\n  padding: 12px 16px !important;\n  font-weight: 700 !important;\n  color: #111827 !important;\n}\n\n.form-control-custom:focus {\n  box-shadow: none !important;\n  border-bottom-color: #3b82f6 !important;\n}\n\n.form-label-custom {\n  font-size: 11px;\n  text-transform: none;\n  color: #6b7280;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n\n.custom-card {\n  border-radius: 20px;\n  border: 1px solid #e0e0e0;\n  background: white;\n  overflow: hidden;\n  height: 100%;\n}\n\n.subscription-card {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.subscription-card.phone {\n  border: 2px solid #a855f7;\n}\n\n.subscription-card.support {\n  border: 2px solid #06b6d4;\n}\n\n.metric-box {\n  padding: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  border-left: 4px solid transparent;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.metric-box.purple { border-left-color: #8C1AFF; }\n.metric-box.cyan { border-left-color: #00E5FF; }\n.metric-box.blue { border-left-color: #3b82f6; }\n\n.avatar-stack {\n  display: flex;\n  align-items: center;\n}\n\n.avatar-stack img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid white;\n  margin-left: -8px;\n}\n\n.avatar-stack img:first-child {\n  margin-left: 0;\n}\n\n.btn-purple {\n  background-color: #a855f7;\n  color: white;\n}\n\n.btn-cyan {\n  background-color: #06b6d4;\n  color: white;\n}\n\n/* Activity Log CSS from jobpro-admin */\n.but-cover {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.but-cover .but {\n  background-color: #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  border-radius: 100%;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.but-cover::before {\n  content: \" \";\n  border-left: 1.5px dashed #4f4f4f;\n  height: 90%;\n  position: absolute;\n  top: 40px;\n  left: 33px;\n}\n\n.child-but-cover {\n  background-color: #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  border-radius: 100%;\n  padding: 8px;\n  position: absolute;\n  left: -15%;\n}\n\n.btn-topup {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  color: #666;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.stat-change {\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.stat-change.up { color: #10b981; }\n.stat-change.down { color: #ef4444; }\n\n.license-control {\n  display: flex;\n  align-items: center;\n  background: #f3f4f6;\n  border-radius: 8px;\n  padding: 4px 12px;\n  width: fit-content;\n}\n\n.license-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #374151;\n  padding: 0 8px;\n}\n\n.chart-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n\n.legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.tab-btn {\n  padding: 8px 16px;\n  border: none;\n  background: none;\n  color: #666;\n  font-weight: 500;\n  border-bottom: 2px solid transparent;\n}\n\n.tab-btn.active {\n  color: #3b82f6;\n  border-bottom-color: #3b82f6;\n  background: #eff6ff;\n  border-radius: 8px 8px 0 0;\n}\n\n.action-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 1rem 0;\n}\n\n.search-input-group {\n  position: relative;\n  flex: 1;\n}\n\n.search-input-group svg {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n}\n\n.search-input-group input {\n  padding-left: 40px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.form-select-custom {\n  line-height: 2rem;\n}\n\n.custom-phone-input {\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 2px;\n}\n\n.custom-phone-input .PhoneInputInput {\n  border: none;\n  font-weight: 700;\n  outline: none;\n}\n\n.custom-phone-input .PhoneInputCountryIcon {\n  border-radius: 50%;\n  overflow: hidden;\n  border: none;\n  box-shadow: none;\n}\n\n.custom-phone-input .PhoneInputCountryIconImg {\n  border-radius: 50%;\n}\n\n.border-purple { border-color: #a855f7 !important; }\n.border-cyan { border-color: #06b6d4 !important; }\n.border-blue { border-color: #3b82f6 !important; }\n\n.text-purple { color: #a855f7; }\n.text-cyan { color: #06b6d4; }\n\n.progress-bar.bg-purple-custom {\n  background-color: #a855f7 !important;\n}\n\n.progress-bar.bg-cyan-custom {\n  background-color: #06b6d4 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
